/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Results_CopiedInputs */



/**
* | output |
* | --- |
* | "Results copied to clipboard" |
*
* @param {Share_Results_CopiedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const share_results_copied = /** @type {((inputs?: Share_Results_CopiedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Results_CopiedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résultats copiés dans le presse-papier")
	if (locale === "es") return /** @type {LocalizedString} */ ("Resultados copiados al portapapeles")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Resultados copiados para a área de transferência")
	if (locale === "it") return /** @type {LocalizedString} */ ("Risultati copiati negli appunti")
	return /** @type {LocalizedString} */ ("Results copied to clipboard")
});